import { DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';

import { type UploadItem as Upload } from '@/hooks/useUploader';

import { UploadIcon } from './UploadIcon';
import { UploadInfo } from './UploadInfo';
import { UploadProgress } from './uploadProgress';

export const UploadItem = ({
  upload,
  abort,
  retry
}: {
  upload: Upload;
  done: boolean;
  abort: (id: string, filename: string) => void;
  retry: (id: string) => void;
}) => {
  return (
    <div
      key={upload.id}
      className='bg-surface-default dark:border-outline-default relative mb-2 overflow-hidden rounded-lg border border-zinc-200'
    >
      <UploadProgress upload={upload} />

      <div className='data relative z-10 flex flex-row gap-2 px-2'>
        <UploadIcon fileName={upload.file.name} />

        <div className='flex flex-1 flex-col p-2'>
          <Tooltip title={upload.file.name}>
            <div className='text-content-title max-w-44 truncate sm:max-w-fit'>{upload.file.name}</div>
          </Tooltip>
          <UploadInfo upload={upload} />
        </div>

        <div className='flex items-center'>
          {upload.status === 'error' && (
            <Tooltip title='Tentar novamente'>
              <Button
                size='small'
                className='cursor-pointer'
                type='text'
                id={`file-${upload.id}`}
                onClick={() => retry(upload.id)}
              >
                <UploadOutlined />
              </Button>
            </Tooltip>
          )}

          <Tooltip title='Cancelar upload'>
            <Button
              size='small'
              className='cursor-pointer'
              type='text'
              id={`file-${upload.id}`}
              disabled={upload.status === 'aborted'}
              onClick={() => abort(upload.deliverableId || upload.id, upload.file.name)}
            >
              <DeleteOutlined />
            </Button>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};
